import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface SuggestedKeyword {
  id: number
  keyword: string
  relevance?: number
}

/**
 * Hook to fetch AI-suggested keywords for an event based on the event description
 *
 * @param eventId - The ID of the event to get keywords for
 * @param editing - If true, disables the query (to prevent unwanted API calls during editing)
 * @returns Query result with suggested keywords
 */
export const useSuggestedKeywordsForEvent = (
  eventId: string,
  editing: boolean = false
) => {
  const fetchWithAuth = useFetchWithAuth()
  const getSuggestedKeywords: QueryFunction<SuggestedKeyword[]> = async () => {
    const response = await fetchWithAuth(
      `${URL}/events/${eventId}/suggest-keywords`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      }
    )
    return response
  }

  return useQuery({
    queryKey: ['suggestedEventKeywords', eventId] as const,
    queryFn: getSuggestedKeywords,
    retry: false,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    enabled: Boolean(eventId) && !editing,
  })
}
